export default __webpack_public_path__ + "static/media/language-hr.d2d76d2a.svg";